import React, { useState } from 'react'
import moment from 'moment'
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'
import AssessmentText from '../AssessmentText'

const MentalHealth = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Stack gap={2} padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Mental Health Assessment</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            size="small"
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            value={moduleValues?.['Presenting Concerns'] ?? []}
            options={[
              'Anxiety',
              'Depression',
              'Psychosis',
              'Suicidal Thoughts',
              'Self-Harm',
              'Aggression / Violence',
              'Confusion',
              'Substance-Induced',
            ]}
            freeSolo
            multiple
            onChange={(e, value) =>
              setModuleValues((prev) => ({
                ...prev,
                'Presenting Concerns': value,
              }))
            }
            renderInput={(params) => (
              <TextField {...params} fullWidth label="Presenting Concerns" />
            )}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl fullWidth>
            <InputLabel>Suicidal Thoughts</InputLabel>
            <Select
              value={moduleValues?.['Suicidal Thoughts'] ?? ''}
              label="Suicidal Thoughts"
              onChange={(e) =>
                setModuleValues((prev) => ({
                  ...prev,
                  'Suicidal Thoughts': e.target.value,
                }))
              }
            >
              <MenuItem value="None">None</MenuItem>
              <MenuItem value="Passive (no plan)">Passive (no plan)</MenuItem>
              <MenuItem value="Active (has plan/means)">
                Active (has plan/means)
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl fullWidth>
            <InputLabel>Self-Harm Risk</InputLabel>
            <Select
              value={moduleValues?.['Self-Harm Risk'] ?? ''}
              onChange={(e) =>
                setModuleValues((prev) => ({
                  ...prev,
                  'Self-Harm Risk': e.target.value,
                }))
              }
              label="Self-Harm Risk"
            >
              <MenuItem value="No history or current intent">
                No history or current intent
              </MenuItem>
              <MenuItem value="History only">History only</MenuItem>
              <MenuItem value="Current intent or recent act">
                Current intent or recent act
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} lg={6}>
          <FormControl fullWidth>
            <InputLabel>Harm to Others</InputLabel>
            <Select
              value={moduleValues?.['Risk of Harm to Others'] ?? ''}
              onChange={(e) =>
                setModuleValues((prev) => ({
                  ...prev,
                  'Risk of Harm to Others': e.target.value,
                }))
              }
              label="Harm to Others"
            >
              <MenuItem value="No Risk">No Risk</MenuItem>
              <MenuItem value="Verbal Threats">Verbal Threats</MenuItem>
              <MenuItem value="Physical Aggression">
                Physical Aggression
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} lg={6}>
          <Autocomplete
            value={moduleValues?.['Support Systems'] ?? []}
            options={[
              'With family/friends',
              'Living alone',
              'Supported accommodation',
              'No fixed address',
              'Known to mental health services',
              'Not known to services',
            ]}
            freeSolo
            multiple
            onChange={(e, value) =>
              setModuleValues((prev) => ({
                ...prev,
                'Support Systems': value,
              }))
            }
            renderInput={(params) => (
              <TextField {...params} fullWidth label="Support Systems" />
            )}
          />
        </Grid>
        <Grid item xs={12} lg={8}>
          <Autocomplete
            value={moduleValues?.['Mood & Behaviour'] ?? []}
            options={[
              'Calm',
              'Agitated',
              'Withdrawn',
              'Tearful',
              'Hostile',
              'Euphoric',
              'Flat affect',
            ]}
            freeSolo
            multiple
            onChange={(e, value) =>
              setModuleValues((prev) => ({
                ...prev,
                'Mood & Behaviour': value,
              }))
            }
            renderInput={(params) => (
              <TextField {...params} fullWidth label="Mood & Behaviour" />
            )}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <FormControl fullWidth>
            <InputLabel>Current Treatment</InputLabel>
            <Select
              value={moduleValues?.['Current Treatment'] ?? ''}
              onChange={(e) =>
                setModuleValues((prev) => ({
                  ...prev,
                  'Current Treatment': e.target.value,
                }))
              }
              label="Current Treatment"
            >
              <MenuItem value="Taking prescribed medications">
                Taking prescribed medications
              </MenuItem>
              <MenuItem value="Non-compliant with medications">
                Non-compliant with medications
              </MenuItem>
              <MenuItem value="Not on any treatment">
                Not on any treatment
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <AssessmentText
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Grid item xs={12}>
          <Button
            onClick={() => submitModule('Mental Health', moduleValues)}
            variant="contained"
            fullWidth
            color="success"
          >
            Submit
          </Button>
        </Grid>
      </Grid>
    </Stack>
  )
}

export default MentalHealth
